<app-loading *ngIf="contentReady"></app-loading>
<div class="container-fluid p-0">
  <div>


    <div class="col-12 col-sm-12 main-content">
      <div class="container-fluid mb-4">
        <div class="categoryContainer">

        <div class="col-12">
            <button routerLink="/createvisaclient" style="margin-left: 0;" class="first-btn btn btn-primary">
              {{ 'Create Client' | translate }}
            </button>
            <!-- <button (click)="exportToExcel()" class="btn first-btn btn-primary">
              {{ "export to excel" | translate }}
            </button> -->

            <button (click)="getAllClients(10, 1)" style="margin-left: 0;" class="first-btn btn btn-primary">
              {{ 'refresh' | translate }}
            </button>
            <div class="input-group mb-3">
              <input type="text" class="form-control" [(ngModel)]="searchKey"
                placeholder="{{ 'searchwith' | translate }}" aria-label="Recipient's username"
                aria-describedby="basic-addon2">
              <div class="input-group-append">
                <button class="btn btn-outline-secondary" (click)="search()" type="button">{{ 'Search' | translate
                  }}</button>
              </div>
            </div>
            <form [formGroup]="data">
              <div class="form-group">
                <label>
                  <input type="checkbox" formControlName="visit" (change)="onTypeChange('0')" />
                  زيارة فرست جروب
                </label>
                <label>
                  <input type="checkbox" formControlName="visa" (change)="onTypeChange('1')" />
                  فيزا فرست جروب
                </label>
              </div>
            </form>


          </div>
        </div>
        <div>
          <table mat-table id="Clients" [dataSource]="dataSource" class="mat-elevation-z8">

            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef>{{ 'Name' | translate }}</th>
              <td mat-cell *matCellDef="let el">{{ el.name }}

              </td>
            </ng-container>


            <ng-container matColumnDef="job">
              <th mat-header-cell *matHeaderCellDef>{{ 'job title' | translate }}</th>
              <td mat-cell *matCellDef="let el">{{ el.job }}</td>
            </ng-container>



            <ng-container matColumnDef="phone">
              <th mat-header-cell *matHeaderCellDef>{{ 'Phone Number' | translate }}</th>
              <td mat-cell *matCellDef="let el">{{ el.phone }}

              </td>
            </ng-container>





            <ng-container matColumnDef="paid">
              <th mat-header-cell *matHeaderCellDef>المدفوع</th>
              <td mat-cell *matCellDef="let el">{{ el.paid}}</td>
            </ng-container>

            <ng-container matColumnDef="remaining">
              <th mat-header-cell *matHeaderCellDef>المتبقي</th>
              <td mat-cell *matCellDef="let el">
                {{ el.remaining}}
              </td>
            </ng-container>



            <ng-container matColumnDef="representative">
              <th mat-header-cell *matHeaderCellDef>المندوب</th>
              <td mat-cell *matCellDef="let el">
                {{ el.representative }}


              </td>
            </ng-container>

            <ng-container matColumnDef="representative_account">
              <th mat-header-cell *matHeaderCellDef>حساب المندوب</th>
              <td mat-cell *matCellDef="let el">
                {{ el.representative_account }}


              </td>
            </ng-container>
            <ng-container matColumnDef="type">
              <th mat-header-cell *matHeaderCellDef> النوع</th>
              <td mat-cell *matCellDef="let el">
                @if(el.type == "0"){
                زيارة فرست جروب
                }
                @else{
                فيزا فرست جروب
                }


              </td>
            </ng-container>
            <ng-container matColumnDef="notes">
              <th mat-header-cell *matHeaderCellDef>ملاحظات </th>
              <td mat-cell *matCellDef="let el">
                {{ el.notes }}


              </td>
            </ng-container>
            <!-- Call -->
            <ng-container matColumnDef="call">
              <th mat-header-cell *matHeaderCellDef class="text-center">{{ 'call' | translate }}</th>
              <td mat-cell *matCellDef="let el" class="text-center">
                <a class="chat" (click)="call(el.phone_number)">
                  <img src="/assets/call.png" alt="Call">
                </a>
              </td>
            </ng-container>

            <!-- Chat -->
            <ng-container matColumnDef="chat">
              <th mat-header-cell *matHeaderCellDef class="text-center">{{ 'chat' | translate }}</th>
              <td mat-cell *matCellDef="let el" class="text-center">
                <a class="chat" (click)="chat(el.phone_number)">
                  <img src="/assets/chat.png" alt="Chat">
                </a>
              </td>
            </ng-container>


            <ng-container matColumnDef="options">
              <th mat-header-cell *matHeaderCellDef> </th>
              <td mat-cell *matCellDef="let element">

                <div class="dropdown">
                  <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton1"
                    data-bs-toggle="dropdown" aria-expanded="false">
                    <i class="fa-solid fa-ellipsis-vertical"></i>
                  </button>
                  <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">


                    <li><a class="dropdown-item" (click)='edit(element)'>
                        {{ "Edit" | translate }} </a></li>


                    <li><a class="dropdown-item" (click)='delete(element.id)'>{{ "Delete" | translate }}</a></li>

                  </ul>
                </div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>

          <mat-paginator
            style="margin-top: 20px; background: #f5f5f5; border: 1px solid #ddd; border-radius: 6px; padding: 10px;"
            [length]="totalItems" [pageSize]="10" (page)="onPaginateChange($event)">
          </mat-paginator>

        </div>

        <div class="row">
          @if (noData) {
          <app-nodata></app-nodata>
          }
        </div>
      </div>
    </div>
  </div>
</div>